import {validNumber} from './validation';

function isValidAMPM(value: string): boolean {
    /**
     * check if type/delete NULL
     */
    if (value === 'N' || value === 'NUL') {
        return true;
    }

    // check valid carachters

    if (value && !value.match(/(\*|_|\?|[0-9:AMPamp?])/)) {
        return false;
    }

    if (value.indexOf(':') > 1) {
        /** check fo only XX:XX format*/
        if (value.split(':').length > 2) {
            return false;
        }
        let valid = true;
        const [hours, minutes] = value.split(':');
        if (hours) {
            valid = hours.length <= 2 && validNumber(hours[0], 1) && validNumber(hours, 12);
        }
        if (minutes) {
            if (value.indexOf(' ') === 5) {
                const [minutes2, AM] = minutes.split(' ');
                if (value.split(' ').length > 2) {
                    return false;
                }
                valid =
                    minutes2.length <= 2 &&
                    validNumber(minutes2[0], 5) &&
                    validNumber(minutes2, 59);
                valid = valid && AM.length <= 2;
                if (AM) {
                    valid = Boolean(valid && AM[0].match(/[AaPp]/));
                    if (AM[1]) {
                        valid = Boolean(valid && AM[1].match(/[mM]/));
                    }
                }
            } else {
                valid =
                    valid &&
                    minutes.length <= 2 &&
                    validNumber(minutes[0], 5) &&
                    validNumber(minutes, 59);
            }
        }
        return valid;
    } else {
        return value.length <= 2 && validNumber(value[0], 1) && validNumber(value, 12);
    }
}

function isValid24(value: string) {
    /**
     * check if type/delete NULL
     */
    if (value === 'N' || value === 'NUL') {
        return true;
    }

    // check valid carachters
    if (value && !value.match(/(\*|_|\?|[0-9:AMPamp?])/)) {
        return false;
    }
    if (value.length === 3 && value[value.length - 1] === ':') {
        return true;
    }

    if (value.indexOf(':') > 1) {
        let valid = true;
        /** check fo only XX:XX format*/
        if (value.split(':').length > 2) {
            return false;
        }
        const [hours, minutes] = value.split(':');
        if (hours) {
            valid = hours.length <= 2 && validNumber(hours[0], 2) && validNumber(hours, 24);
        }
        if (minutes) {
            valid = minutes.length <= 2 && validNumber(minutes[0], 5) && validNumber(minutes, 59);
        }
        return valid;
    } else {
        return value.length <= 2 && validNumber(value[0], 2) && validNumber(value, 24);
    }
}

export function isValid(value: string, format: string): boolean {
    return format === 'HH:mm' ? isValid24(value) : isValidAMPM(value);
}

export function TimeValidator(value, format) {
    return isValid(value, format);
}
